class Language {
	id = null;
	name = '';
	code = '';
	additional_information = '';

	constructor(data) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}
	}
}

export default Language;
